import { Form, Row, Col, Input, Icon, Modal } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { login as config } from './formConfig';
import { LoginPending, LoginSuccess, LoginFailure } from './AfspFormStatus';

const
{ key } = config, {
    setEnvPrefix,
    simpleObjectCompare
} = ssCommonUtils, {
    validateForm,
    validateSubForm,
} = ssFormValidationUtils, {
    generateInputComponent,
    setMaxWidth
} = ssFormUtils;

export default class extends React.Component {
    state = { isValid: false }
    constructor(props) { super(props); }

    componentDidUpdate(prev) {
        const
        { services, state: { registrationForm }} = this.props,
        form = registrationForm[key],
        prevForm = prev.state.registrationForm[key],
        { storeForm } = services;

        if(!simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    logInFromPasswordField = (e) => {
        const
        { services, state: { registrationForm, login }} = this.props,
        form = registrationForm[key];

        if(!login.loginButtonDisabled && e.key === 'Enter') {
            services.toggleAfspLoginStatusModal();
            services.doAfspLogin(form);
        }
    }

    render() {
        const {
            registrationPath,
            services: { storeForm, storeFormField, toggleAfspPasswordResetModal },
            state: { registrationForm, login: { showLoginStatusModal, loginRequest: { status }}}
        } = this.props,
        form = registrationForm[key];

        return (
            <div style={{ marginBottom: '20px' }}>
                {!showLoginStatusModal ? null : (
                    <div>{
                        status === 'pending' ? <LoginPending {...this.props} />
                        : status === 'success' ? <LoginSuccess {...this.props} />
                        : status === 'failure' ? <LoginFailure {...this.props} />
                        : null
                    }</div>
                )}
                <Form>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                        <Col span={24}>
                            <Input
                                {...setMaxWidth(generateInputComponent('username', config, true, form, storeFormField, storeForm))}
                                prefix={<Icon type='user' style={{ fontSize: '13px', color: 'rgba(0,0,0,.25)' }} />}
                                placeholder='Username'
                                disabled={status != null ? true : false}
                                aTag = 'loginform username input'
                            />
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={24}>
                            <Input
                                {...setMaxWidth(generateInputComponent('password', config, true, form, storeFormField, storeForm))}
                                prefix={<Icon type='lock' style={{ fontSize: '13px', color: 'rgba(0,0,0,.25)' }} />}
                                placeholder='Password'
                                type='password'
                                autocomplete='off'
                                disabled={status != null ? true : false}
                                onKeyPress={this.logInFromPasswordField}
                                aTag='loginform password input'
                            />
                        </Col>
                    </Row>
                </Form>
                <div style={{ marginTop: '18px' }}>
                    <div className='afsp-login-option'>
                        <span
                            className='afsp-login-option-clickable'
                            onClick={() => toggleAfspPasswordResetModal('forgot-password')}
                            id = "loginform forgotIdPass link"
                            aTag = "loginform forgotIdPass link"
                        >
                            <Icon  type='question-circle' style={{ marginRight: '6px' }} />
                            {'Forgot User ID or password'}
                        </span>
                    </div>
                    <div className='afsp-login-option' style={{ margin: '0px 15px' }}>
                        <span
                            className='afsp-login-option-clickable'
                            onClick={() => window.location.href = setEnvPrefix('/home/candidateregistration')}
                            id = "loginform register link"
                            aTag = "loginform register link"
                        >
                            <Icon  type='user-add' style={{ marginRight: '6px' }} />
                            {'Register'}
                        </span>
                    </div>
                    <div className='afsp-login-option' style={{ margin: '0px 15px' }}>
                        <span
                            className='afsp-login-option-clickable'
                            onClick={() => window.location.href = setEnvPrefix('/home/candidaterecovery')}
                            id = "loginform register link"
                            aTag = "loginform register link"
                        >
                            <Icon  type='lock' style={{ marginRight: '6px' }} />
                            {'Account Recovery'}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}